import { SectionRegistrationAttribute } from '../builders/section_registraion_attributes_builder';
import { ISectionRegistrationAttributesDatasource } from '../datasources/section_registration_attributes_datasource';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RegistrationAttributesFacade } from '../facades/registration_attributes_facade';
import { RegistrationAttributesServant } from '../servants/registration_attributes_servant';

export type LoadSectionRegistrationAttributesCommand = (sectionId: number) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'loadSectionRegistrationAttributesCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      ngRegistrationAttributesFacade: RegistrationAttributesFacade,
      log: any,
      ngSectionRegistrationAttributesDatasource: ISectionRegistrationAttributesDatasource
    ) => {
      return defineCommandORM('loadSectionRegistrationAttributesCommand', (deferred, sectionId: number) => {
        const sectionRegAttrFeatureEnabled = ngRegistrationAttributesFacade.isFeatureEnabled();
        if (!sectionRegAttrFeatureEnabled) {
          deferred.resolve();
          return;
        }

        $http
          .get(`reg/configurable_attribute_options/${sectionId}/`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            const attributes = Array.isArray(data)
              ? data.map((attribute: SectionRegistrationAttribute) => {
                  const modifiedAttribute = {
                    ...attribute,
                    required: true,
                    name: attribute.name + `${RegistrationAttributesServant.sectionSeperatorChar}${attribute.section}`
                  };
                  if (_4.isArray(attribute.options) && attribute.options.length === 1) {
                    modifiedAttribute.initial_value = _4.first(attribute.options).value;
                  }
                  return modifiedAttribute;
                })
              : [];
            ngSectionRegistrationAttributesDatasource.put({
              id: sectionId,
              attributes
            });
            deferred.resolve();
          })
          .catch((e) => {
            log.issue(`Failed to load the registration attributes for section(${sectionId})`);
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/commands/load_section_registration_attributes_command.ts